/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Create_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Create new style guide" |
*
* @param {Style_Guide_Manager_Create_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_create_aria_label = /** @type {((inputs?: Style_Guide_Manager_Create_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Create_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Creer un nouveau guide de style")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neuen Styleguide erstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Crea una nuova guida di stile")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создать новое руководство по стилю")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crear una nueva guía de estilo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建新的风格指南")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいスタイルガイドを作成する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नई स्टाइल गाइड बनाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criar novo guia de estilo")
	return /** @type {LocalizedString} */ ("Create new style guide")
});